import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

export const useRouteToReceivement = () => {
  const history = useHistory()

  const routeToReceivement = useCallback(
    ({ receivementId, receivementStatus, id_user_release }) => {
      const routes = {
        IN_ATTENDANCE: `/receivement/${receivementId}`,
        IN_BARCODE_RESOLUTION: `/receivement/${receivementId}/batches-without-barcode`,
        DIVERGENCE_OPENED: `/receivement/${receivementId}/divergence`,
        DIVERGENCE_FINISHED: `/receivement/${receivementId}/overview`,
        SALES_APPROVAL_FINISHED: `/receivement/${receivementId}/finish`,
        SALES_APPROVAL_OPENED: `/receivement/${receivementId}/finish`,
        WAITING_TRUCK_DRIVER_CONFIRMATION: `/receivement/${receivementId}/finish`,
        PROCESSING_TRUCK_DRIVER_CONFIRMATION: `/receivement/${receivementId}/finish`,
        PROCESSING_AFTER_OVERVIEW: `/receivement/${receivementId}/finish`,
      }

      if (!id_user_release) {
        routes["FINISHED"] = `/receivement/${receivementId}/finish`
      }

      const routeTo = routes[receivementStatus]

      if (routeTo) {
        history.push(routeTo)
      } else {
        toast.error('Recebimento sob outra responsabilidade. Não foi possível realizar o redirecionamento.')
      }
    },
    [history]
  )

  return {
    routeToReceivement
  }
}
